// extracted by mini-css-extract-plugin
export default {"heading_container":"HeadingWithGrid_heading_container__22rE9","heading":"HeadingWithGrid_heading__zExk+"};